define( function() {
	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/var/pnum.js
// module id = 619
// module chunks = 0